import React from 'react';
import "./EnvData.css"
import EnvDataTable from './EnvDataTable.tsx';
import temperatureIcon from "../../../assets/temperatureIcon.svg";

const EnvData = () =>{
    return (
        <div className='apiGatewayMainContainer' style={{paddingTop: "10px"}}>
             <div className='devicesEnvDataTopContainer'>
                <span><img className='temperatureIcon' style={{marginTop:"3px"}} src={temperatureIcon} alt="batteryIcon" /></span>
                <p className='DevicesInfoHeading'>Environmental Monitoring</p>
            </div>
            <EnvDataTable />
        </div>
    )
}

export default EnvData;